module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/4/1-6a47279c48bc1812591b729f4dfde675.jpg";